import React from "react";
import { PageLayout } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";
import MarketVisitReportForm from "./components/MarketVisitReportForm";

// Market Visit Report Feature
// Main export point for the feature

// Export main component
export { default as MarketVisitReportForm } from "./components/MarketVisitReportForm";

// Export hooks
export * from "./hooks";

// Export services
export * from "./services/marketVisitReportService";

// Export sub-components (for advanced usage)
export * from "./components";

// Default export
export { default } from "./components/MarketVisitReportForm";

/**
 * MarketVisitReportPage - Page wrapper
 * Renders PageLayout + MarketVisitReportForm
 */
export const MarketVisitReportPage = () => {
  usePageInitialization();
  return (
    <PageLayout title="Market Visit Report" backPath="/">
      <MarketVisitReportForm />
    </PageLayout>
  );
};
